import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Clear from '@crehana/crehana-icons/lib/Clear';
import cn from 'classnames';
import styled from 'styled-components';
import IconButton from '../Buttons/IconButton';
import { NotificationTypes } from './types';
import { ROOT } from './classnames';
import { baseLighter } from '../styles/colors';

const NotificationContainer = styled.div<{
  show: boolean;
  noPadding: boolean;
  customWidth: number;
}>`
  opacity: 0;
  width: 90%;
  bottom: 16px;
  transform: translateY(250px);
  transition: transform 0.35s ease-in-out, opacity 0.35s ease-in-out;
  right: 0;
  height: min-content;
  display: block;
  height: -moz-min-content;
  margin: 0 auto;
  padding: ${props => (props.noPadding ? '0px' : '24px')};
  @media (min-width: 768px) {
    width: ${props => props.customWidth}px;
    height: min-content;
    height: -moz-min-content;
    bottom: 24px;
    margin: 0 0 0 auto;
    right: 24px;
    transform: translateX(120%);
  }
  ${props => {
    if (props.show) {
      return `
      opacity: 1;
      transform: translateY(0);
      @media (min-width: 1024px) {
        transform: translateX(0);
      }
      `;
    }
  }}
`;

const Notification = ({
  open,
  className,
  children,
  onRequestClose,
  customWidth = 488,
  noPadding = false,
  showCloseButton = true,
}: NotificationTypes) => {
  const isServer = typeof window === 'undefined';
  const [isOpen, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!isServer) {
      document.body.style.overflowX = 'hidden';
    }
    setOpen(open);
  }, [open]);

  const closeNotification = () => {
    if (onRequestClose) {
      onRequestClose();
    }
    setOpen(false);
  };

  if (isServer) {
    return null;
  }

  return ReactDOM.createPortal(
    <NotificationContainer
      className={`${cn(ROOT, className)} shadow-dropdown`}
      show={isOpen}
      noPadding={noPadding}
      customWidth={customWidth}
    >
      {showCloseButton && (
        <IconButton
          className="absolute cursor-pointer"
          xs
          onClick={() => {
            closeNotification();
          }}
          onKeyDown={() => {
            closeNotification();
          }}
          customIcon={Clear}
          customColor={baseLighter}
          style={{ top: 8, right: 8 }}
          customSize={20}
        />
      )}
      {children}
    </NotificationContainer>,
    document.body,
  );
};

export default Notification;
